/* ============================================================
   fetchAllPages — every row of a paged list endpoint.

   For the places that need the whole set rather than one screen of it: pickers,
   per-person counts, reports and exports. A single `top: 500` call silently
   drops row 501 onward, so this asks one page at a time until the endpoint's
   `total` is reached (or a short page shows there is nothing more).

   `fetchPage({ top, skip })` maps those onto the endpoint's own names
   (candidates.js list() takes limit/offset and sends /candidate/fetch's top/skip)
   and returns the raw `{ data, total }`.
   `pageSize` must not exceed the endpoint's ceiling (500 on /jobs/fetch).
   ============================================================ */

const MAX_ROWS = 50_000

export async function fetchAllPages(fetchPage, { pageSize = 500 } = {}) {
  const rows = []
  for (let skip = 0; skip < MAX_ROWS; skip += pageSize) {
    const res = await fetchPage({ top: pageSize, skip })
    const page = Array.isArray(res?.data) ? res.data : []
    rows.push(...page)
    const total = typeof res?.total === 'number' ? res.total : null
    if (page.length < pageSize || (total != null && rows.length >= total)) break
  }
  return rows
}
